import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useState } from 'react';
import { Menu, X, Sparkles, LogOut, Coins } from 'lucide-react';
import clsx from 'clsx';

const authedLinks = [
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/evaluate', label: 'Evaluate' },
  { to: '/generate', label: 'Generate' },
  { to: '/rubric', label: 'Rubric' },
  { to: '/history', label: 'History' },
];

const publicLinks = [
  { to: '/#features', label: 'Features' },
  { to: '/pricing', label: 'Pricing' },
];

export default function Navbar() {
  const { user, signOut } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const links = user ? authedLinks : publicLinks;

  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur border-b border-ink-200">
      <div className="container-wide flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 font-semibold text-ink-900">
          <span className="w-8 h-8 rounded-lg bg-gradient-to-br from-brand-500 to-brand-700 text-white grid place-items-center shadow-pop">
            <Sparkles className="w-4 h-4" />
          </span>
          <span className="hidden sm:inline">GradeLab</span>
          <span className="sm:hidden">GradeLab</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                clsx(
                  'px-3 py-2 text-sm rounded-lg transition-colors',
                  isActive ? 'text-brand-700 bg-brand-50' : 'text-ink-600 hover:text-ink-900 hover:bg-ink-100'
                )
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <span className="chip bg-brand-50 text-brand-700 border border-brand-100">
                <Coins className="w-3.5 h-3.5 mr-1" /> {user.credits} credits
              </span>
              <img
                src={user.avatarUrl || `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(user.name)}`}
                alt=""
                className="w-8 h-8 rounded-full ring-2 ring-white shadow-sm"
              />
              <button onClick={async () => { await signOut(); nav('/'); }} className="btn-ghost btn-sm">
                <LogOut className="w-4 h-4" /> Sign out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-secondary btn-sm">Sign in</Link>
              <Link to="/login" className="btn-primary btn-sm">Get started</Link>
            </>
          )}
        </div>

        <button className="md:hidden p-2 rounded-lg hover:bg-ink-100" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-ink-200 bg-white animate-fade-in">
          <div className="container-wide py-3 flex flex-col">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  clsx('px-3 py-2.5 rounded-lg', isActive ? 'bg-brand-50 text-brand-700' : 'text-ink-700 hover:bg-ink-100')
                }>
                {l.label}
              </NavLink>
            ))}
            <div className="mt-2 pt-3 border-t border-ink-100 flex gap-2">
              {user ? (
                <button onClick={async () => { setOpen(false); await signOut(); nav('/'); }} className="btn-secondary btn-sm w-full">
                  <LogOut className="w-4 h-4" /> Sign out
                </button>
              ) : (
                <>
                  <Link to="/login" className="btn-secondary btn-sm flex-1" onClick={() => setOpen(false)}>Sign in</Link>
                  <Link to="/login" className="btn-primary btn-sm flex-1" onClick={() => setOpen(false)}>Get started</Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
